import pulse from '@finn-no/pulse-sdk';

pulse.setState({
    vertical: {
        name: 'common_pages',
        subVertical: 'notifications',
    },
});

export function pageTrackEidVerificationModalPopup() {
    pulse.trackPageView({
        object: {
            type: 'UserProfilePage',
            pageType: 'my_account',
            name: 'Eid verification popup',
        },
    });
}

export function onModalClose() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Click',
        name: 'Lukk eid verifikasjon popup modal',
        target: {
            id: 'close-eid-verification-popup',
            referralCommission: false,
            provider: 'FINN',
            name: 'Close modal',
            type: 'ExternalContent',
        },
        object: {
            id: 'eid-verification-popup-close-button',
            type: 'UIElement',
            elementType: 'Button',
            name: 'UserProfilePage',
        },
    });
}

export function onBankIdVerify() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Click',
        name: 'Verifiser med Bankid',
        target: {
            id: 'verify-with-bankid',
            referralCommission: false,
            provider: 'FINN',
            name: 'Go to website',
            type: 'ExternalContent',
        },
        object: {
            id: 'eid-verify-with-bankid-button',
            type: 'UIElement',
            elementType: 'Button',
            name: 'UserProfilePage',
        },
    });
}
